/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Set_Not_FoundInputs */

const en_us2_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server could not find this set.`)
};

const pt_br2_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O servidor não encontrou esta série.`)
};

const es_419_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El servidor no encontró esta serie.`)
};

const pt_pt2_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O servidor não encontrou esta série.`)
};

const fr_fr2_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le serveur n'a pas trouvé cette série.`)
};

const de_de2_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Server hat diesen Satz nicht gefunden.`)
};

const it_it2_workout_set_not_found = /** @type {(inputs: Workout_Set_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il server non ha trovato questa serie.`)
};

/**
* | output |
* | --- |
* | "The server could not find this set." |
*
* @param {Workout_Set_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_not_found = /** @type {((inputs?: Workout_Set_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_not_found(inputs)
	if (locale === "es-419") return es_419_workout_set_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_not_found(inputs)
	if (locale === "de-DE") return de_de2_workout_set_not_found(inputs)
	if (locale === "it-IT") return it_it2_workout_set_not_found(inputs)
	return en_us2_workout_set_not_found(inputs)
});
export { workout_set_not_found as "workout.set_not_found" }